import { render } from "./FavoritesPage.vue?vue&type=template&id=2f223b4e&ts=true"
import script from "./FavoritesPage.vue?vue&type=script&lang=ts"
export * from "./FavoritesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__